import { Component } from '@angular/core';
import {  MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-logout-popup',
  standalone: false,
  templateUrl: './logout-popup.html',
  styleUrl: './logout-popup.scss'
})
export class LogoutPopup {

  constructor(
    private readonly dialogRef: MatDialogRef<LogoutPopup>,
  ) { }

  close() {
    this.dialogRef.close(false);
  }

  confirmLogout(): void {
    this.dialogRef.close(true);
  }
}